import { SET_SPLASH_SCREEN_STATE } from './splashScreen.type';

export const setSplashScreenStateAction = (payload) => ({
  type: SET_SPLASH_SCREEN_STATE,
  payload: payload,
});
